/**
 * Karbantartási flag-ek.
 *
 * `PRE_LAUNCH_MODE` — pályázati elbírálás miatt a teljes oldal helyett csak egy
 * "Hamarosan" felirat látszik a hero kép tetején. A többi szekció a DOM-ban marad
 * (display:none), hogy a Google továbbra is indexelni tudja és ne vesszen el a
 * SEO-pozíció. Amikor élesen indul az oldal, állítsd `false`-ra.
 *
 * `BOOKING_DISABLED` — finomabb fokozat: az oldal teljesen látható, csak a
 * foglalási és utalvány-vásárló gombok nem nyitnak meg űrlapot, hanem előre-
 * kitöltött e-mailt nyitnak a fallback címre. A tetején egy notifikációs sáv
 * jelzi a helyzetet. Akkor használandó, amikor a Rackhost e-mail probléma
 * fennáll, de már nem akarjuk a teljes "Hamarosan" oldalt.
 *
 * Ha mindkettő `true`, a PRE_LAUNCH_MODE győz.
 */
export const PRE_LAUNCH_MODE = false;
export const BOOKING_DISABLED = false;

export const FALLBACK_EMAIL = 'ahaaziko@gmail.com';
export const FALLBACK_PHONE = '+36 30 637 7352';
